exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".wait-spinner{z-index:100}.wait-spinner .top-section{position:absolute;width:calc(100% - 250px);height:100%;z-index:100;background-color:transparent}.wait-spinner .top-section .loader{margin:auto}.wait-spinner .top-section .lds-ellipsis{position:absolute;left:50%;top:50%;transform:translate(-50%,-50%)}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader!./src/components/WaitSpinner/WaitSpinner.scss
// module id = 1685
// module chunks = 0